import React from 'react';
import PropTypes from 'prop-types';
import {
  Field,
} from 'react-final-form';

import {
  Col,
  Row,
  TextField,
} from '@folio/stripes/components';

import {
  ICONS,
  RECORD_LINK_FIELDS,
  RECORD_LINK_INITIAL_VALUES,
  UPDATE_STATUS,
  DISPLAY_FLEX,
  DISPLAY_NONE,
} from '../../../../../../constants';
import ActionButtonWithTooltip from '../../../../action-button-with-tooltip';

import css from './record-linkage-row.css';

const isRowVisible = (index, fields) => {
  return fields.value[index][RECORD_LINK_FIELDS.UPDATE_STATUS] !== UPDATE_STATUS.DELETE;
};

const getRowStyle = (index, fields) => {
  return {
    display: isRowVisible(index, fields) ? DISPLAY_FLEX : DISPLAY_NONE,
  };
};
const isAddButtonVisible = (index, fields) => {
  return fields.length === index + 1;
};

const addAfterCurrentByIndex = (index, fields) => {
  const onClickHandler = () => {
    fields.insert(index + 1, RECORD_LINK_INITIAL_VALUES);
  };

  return (
    <ActionButtonWithTooltip
      icon={ICONS.ADD}
      index={index}
      onClickHandler={onClickHandler}
    />
  );
};

const deleteCurrentByIndex = (index, fields) => {
  const onClickHandler = () => {
    if (fields.value[index][RECORD_LINK_FIELDS.UPDATE_STATUS] === UPDATE_STATUS.ADD) {
      fields.remove(index);
    } else {
      fields.update(index, {
        ...fields.value[index],
        [RECORD_LINK_FIELDS.UPDATE_STATUS]: UPDATE_STATUS.DELETE,
      });
    }
  };

  return (
    <ActionButtonWithTooltip
      icon={ICONS.DELETE}
      index={index}
      onClickHandler={onClickHandler}
    />
  );
};

const updateFormFieldOnChangeHandler = (index, fields, event, formFieldName) => {
  fields.update(index, {
    ...fields.value[index],
    [formFieldName]: event.target.value,
    [RECORD_LINK_FIELDS.UPDATE_STATUS]: fields.value[index][RECORD_LINK_FIELDS.UPDATE_STATUS] === UPDATE_STATUS.ADD
      ? UPDATE_STATUS.ADD
      : UPDATE_STATUS.UPDATE,
  });
};

const updateNameOnChangeHandler = (index, fields) => (event) => {
  return updateFormFieldOnChangeHandler(index, fields, event, RECORD_LINK_FIELDS.NAME);
};

const updateUrlOnChangeHandler = (index, fields) => (event) => {
  return updateFormFieldOnChangeHandler(index, fields, event, RECORD_LINK_FIELDS.URL);
};

const RecordLinkageRow = ({
  index,
  link,
  fields,
}) => {
  return (
    <Row
      data-test-record-linkage-edit-row
      key={index}
      className={css.recordLinkageRow}
      style={getRowStyle(index, fields)}
    >
      <Col
        data-test-record-linkage-edit-name
        className={css.recordLinkageRowCell}
        sm={2}
      >
        <Field
          required
          component={TextField}
          id={`${RECORD_LINK_FIELDS.NAME}_${index}`}
          name={`${link}.${RECORD_LINK_FIELDS.NAME}`}
          type="text"
          onChange={updateNameOnChangeHandler(index, fields)}
        />
      </Col>
      <Col
        data-test-record-linkage-edit-url
        className={css.recordLinkageRowCell}
        sm={9}
      >
        <Field
          required
          component={TextField}
          id={`${RECORD_LINK_FIELDS.URL}${index}`}
          name={`${link}.${RECORD_LINK_FIELDS.URL}`}
          type="text"
          onChange={updateUrlOnChangeHandler(index, fields)}
        />
      </Col>
      <Col
        className={css.recordLinkageRowCell}
        sm={1}
      >
        <Row>
          <Col sm={6}>
            {
              isAddButtonVisible(index, fields) && (
                addAfterCurrentByIndex(index, fields)
              )
            }
          </Col>
          <Col sm={6}>
            {deleteCurrentByIndex(index, fields)}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

RecordLinkageRow.propTypes = {
  fields: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  link: PropTypes.string.isRequired,
};

export default RecordLinkageRow;
